import React from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'

import Credentials from 'components_new/pages/Credentials'

// Collect
import Source from 'components_new/pages/internal/Source'
import Sources from 'components_new/pages/internal/Sources'

// Ontology
import OntologyStandard from 'components_new/pages/internal/OntologyStandard'
import OntologyCustom from 'components_new/pages/internal/OntologyCustom'

import SimTable from 'components_new/pages/SimTable'

import { useIsAuthenticated } from 'redux/hooks/SignedInAccount'

import AuthRoute from './AuthRoute'

const Routes = () => {
  const isAuthenticated = useIsAuthenticated()

  return (
    <Switch>
      {/* Ontology routes */}
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={OntologyStandard}
        path={'/data-platform/ontology/standard'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={OntologyCustom}
        path={'/data-platform/ontology/custom'}
        exact
      />
      {/* Collect routes - saving /collect for overview. */}
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={Sources}
        path={'/data-platform/collect/sources'}
      />
      {/*
        :sourceType has to stay the fourth segment - the source list builds its
        links from it and the specific pages read it back out of the pathname.
      */}
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={Source}
        path={
          '/data-platform/collect/:sourceType/:id/' +
          ':tab(data|endpoints|upload)'
        }
      />
      <Route exact path={'/data-platform/collect/:sourceType/:id'}>
        {({ match }) => (
          <Redirect
            to={`/data-platform/collect/${match.params.sourceType}/${match.params.id}/data`}
          />
        )}
      </Route>
      {/* Credentials */}
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={Credentials}
        path={'/security/credentials'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <SimTable />}
        path={'/data-platform/standard/tables/:tableId'}
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <SimTable />}
        path={'/data-platform/custom/tables/:tableId'}
      />
      <Route path={'/data-platform'}>
        <Redirect to="/data-platform/ontology/standard" />
      </Route>
      <Route path={'/data-platform/*'}>
        <Redirect to="/data-platform/ontology/standard" />
      </Route>
    </Switch>
  )
}

export default Routes
